import React from "react";
import { FaWhatsapp, FaPhone, FaEnvelope } from "react-icons/fa";
import "./Header.css";

const Header = () => {
  return (
    <header>
      {/* Top bar */}
      <div className="top-bar">
        <div className="right">
          <a
            href="https://api.whatsapp.com/send?phone=919413188887&text=Hello"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-item"
          >
            <FaWhatsapp className="icon whatsapp-icon" /> 94131-88887
          </a>

          <a href="tel:+919829326555" className="contact-item">
            <FaPhone className="icon phone-icon" /> 98293-26555
          </a>

          <a href="mailto:info@taxowealth.com" className="contact-item">
            <FaEnvelope className="icon email-icon" /> info@taxowealth.com
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
